import { Component, OnDestroy, inject } from '@angular/core';
import { SiteState } from '@next/core-lib/site';
import { WindowService, WindowServiceInjector } from '@next/core-lib/window';
import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';

import * as LegalStandardSelectors from '../../store/fertilization-legal-standard.selectors';

@Component({
  selector: 'app-fertilization-legal-standards-quick-view',
  templateUrl: './fertilization-legal-standards-quick-view.component.html',
  standalone: false,
})
export class FertilizationLegalStandardsQuickViewComponent implements OnDestroy {
  private readonly store = inject<Store<SiteState>>(Store);
  private readonly window = inject<WindowService>(WindowServiceInjector);

  legalStandardBalance$ = this.store.pipe(
    select(LegalStandardSelectors.selectLegalStandardBalance),
  );
  private readonly destroyed$ = new Subject<boolean>();
  ngOnDestroy() {
    this.destroyed$.next(true);
  }

  print() {
    this.window.print();
  }
}
